:host {
    display: block;
    position: relative;
    width: 100%;

    @media (prefers-reduced-motion: reduce) {
        * {
            transition: none !important;
        }
    }
}

.slider-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.scroll-container {
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.1);
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.3);
        border-radius: 4px;

        &:hover {
            background: rgba(0, 0, 0, 0.5);
        }
    }
}

.slides-wrapper {
    white-space: nowrap;
}

::slotted(*) {
    margin: 0 10px 0 0;
    display: inline-block;
    white-space: normal;
}

::slotted(:last-child) {
    margin-right: 0;
}

.gradient-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 300px;
    z-index: 2;
    pointer-events: none;
    opacity: 0;
    transition: opacity 300ms ease-in-out;

    &.visible {
        opacity: 0.7;
    }

    &.gradient-left {
        left: 0;
        background: linear-gradient(
            270deg,
            rgba(248, 248, 248, 0) 68.99%,
            #f8f8f8 97.77%
        );
    }

    &.gradient-right {
        right: 0;
        background: linear-gradient(
            90deg,
            rgba(248, 248, 248, 0) 68.99%,
            #f8f8f8 97.77%
        );
    }
}

.nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 60px;
    background: #fff;
    box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    opacity: 0;
    pointer-events: none;
    transition: all 300ms ease-in-out;
    border: 0;

    &.visible {
        opacity: 1;
        pointer-events: auto;
    }

    &:hover {
        color: var(--ux-button-primary-hover-text-color);
    }

    &:active {
        transform: translateY(-50%) scale(0.95);
    }

    &.nav-button-left {
        left: 0;
    }

    &.nav-button-right {
        right: 0;
    }

    ux-icon {
        font-size: 30px;
        transition: color 300ms ease-in-out;
    }

    &:focus-visible {
        outline: 2px solid #005074;
        outline-offset: 2px;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
}

// Make sure slotted content fits properly
::slotted(*) {
    flex-shrink: 0;
    height: 100%;
}

// Media queries for responsive behavior
@media (max-width: 768px) {
    .slides-wrapper {
        padding: 0 10px;
        gap: 15px;
    }

    .nav-button {
        width: 40px;
        height: 40px;

        &.nav-button-left {
            left: 5px;
        }

        &.nav-button-right {
            right: 5px;
        }

        ux-icon {
            font-size: 16px;
        }
    }

    .gradient-overlay {
        width: 40px;
    }
}
